import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/logo_white.svg'


const _hoisted_1 = { class: "authentication-page" }
const _hoisted_2 = { class: "authentication-page__body" }
const _hoisted_3 = { class: "authentication-page__card" }
const _hoisted_4 = {
  key: 0,
  class: "authentication-page__card-header"
}
const _hoisted_5 = { class: "authentication-page__card-body" }
const _hoisted_6 = {
  key: 0,
  class: "authentication-page__card-links"
}
const _hoisted_7 = { class: "authentication-page__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_projectCenterBlack = _resolveComponent("projectCenterBlack")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "authentication-page__banner" }, [
      _createElementVNode("img", {
        class: "authentication-page__banner-logo",
        src: _imports_0
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_projectCenterBlack)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      (_ctx.showLinks)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: _ctx.paths.unauthenticatedTermsConditions
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.links.termsConditions')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["to"]),
              _cache[0] || (_cache[0] = _createTextVNode(" | ", -1)),
              _createVNode(_component_router_link, {
                to: _ctx.paths.unauthenticatedPrivacyPolicy
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.links.privacyPolicy')), 1)
                ], undefined, true),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.copyright', { year: _ctx.year })), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('login.footer')), 1)
  ]))
}